import { SET_ALERT, REMOVE_ALERT } from './types.js'

export default {
  showToast({ commit }, text) {
    commit(SET_ALERT, text)
    setTimeout(() => {
      commit(REMOVE_ALERT)
    }, 2100)
  },
}
